<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="editName == ''" class="p-d-flex p-ai-baseline">{{ template.name }} / {{ template.category
                }}<Button icon="pi pi-pencil" class="p-button-link"
                        @click="editName = template.name; editCategory = template.category" /></h4>
                <div class="p-inputgroup p-lg-6 p-md-12 p-p-0 p-mb-2" v-else>
                    <Button label="Cancel" @click="editName = ''; editCategory = ''"
                        class="p-button-link p-disabled p-order-1" />
                    <InputText type="text" class="p-inputtext-lg p-col" placeholder="Large" v-model="editName" autofocus />
                    <InputText type="text" class="p-inputtext-lg p-col" placeholder="Large" v-model="editCategory" />
                    <Button icon="pi pi-save" @click="saveName" class="p-button-primary p-button-lg" />
                </div>
                <!-- <p>Description of template.</p> -->
                <DataTable :value="templateProperties" :paginator="true" class="p-mb-4" :rows="10" dataKey="key"
                    :rowHover="true" :filters="filters" :loading="loading" sortField="name" :sortOrder="1">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            List of Properties
                            <div>
                                <Button label="Delete Selected" icon="pi pi-trash" @click="openConfirmation"
                                    class="p-button-danger" v-if="selectedRows.length" />
                                <span class="p-input-icon-left p-mt-2 p-ml-md-2">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global']" placeholder="Property Search" />
                                </span>
                            </div>
                        </div>
                    </template>
                    <template #empty>
                        No properties found.
                    </template>
                    <template #loading>
                        Loading properties data. Please wait.
                    </template>
                    <Column field="name" header="Name" :sortable="true">
                        <template #body="slotProps">
                            <b>{{ slotProps.data.name }}</b>
                        </template>
                    </Column>
                    <Column field="value" header="Value" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.value }}
                        </template>
                    </Column>
                    <Column headerStyle="width: 8rem; text-align: right" bodyStyle="text-align: right; overflow: visible">
                        <template #body="slotProps">
                            <!-- <Button type="button" icon="pi pi-cog" class="p-button-secondary"></Button> -->
                            <!-- <Button type="button" icon="pi pi-angle-down" @click="toggleMenu($event,slotProps.data.key)" class="p-button-secondary"/> -->
                            <Button type="button" icon="pi pi-pencil" class="p-button-secondary p-mr-2"
                                @click="visibleRight = true; selected = Object.assign({}, slotProps.data);"></Button>
                            <Button type="button" icon="pi pi-trash"
                                @click="openConfirmation($event, slotProps.data.key)" />
                        </template>
                    </Column>
                </DataTable>
                <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{ width: '350px' }" :modal="true">
                    <div class="confirmation-content">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                        <span>Are you sure you want to proceed?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" @click="closeConfirmation(false)" class="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" @click="closeConfirmation(true)" class="p-button-text"
                            autofocus />
                    </template>
                </Dialog>
                <div class="p-d-flex p-jc-end">
                    <Button label="New Property" icon="pi pi-plus" class="p-button-secondary" @click="visibleRight = true"
                        iconPos="right" />
                    <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right">
                        <h1 style="fontWeight:normal">Add/Edit Property</h1>
                        <div class="p-float-label p-my-5">
                            <InputText id="name" type="text" v-model="selected.name" />
                            <label for="name">Property Name</label>
                        </div>
                        <div class="p-float-label p-my-4">
                            <InputText id="value" type="text" v-model="selected.value" />
                            <label for="value">Property Value</label>
                        </div>
                        <Button type="button" @click="addProperty" label="Save" class="p-button-success"
                            style="margin-right:.25em" />
                        <Button type="button" @click="visibleRight = false" label="Cancel" class="p-button-secondary" />
                    </Sidebar>
                </div>
            </div>
            <div class="card">
                <h5>Documents</h5>
                <FileUpload name="template_docs[]" :customUpload="true" @uploader="startUpload" :multiple="true"
                    accept="image/*,.pdf" :maxFileSize="2000000" ref="uploader" class="p-mb-3" />
                <div class="p-fileupload-files" v-if="templateDocuments">
                    <div class="p-fileupload-row p-mb-1" v-for="(file, index) of templateDocuments"
                        :key="file.name + file.type + file.size">
                        <div v-if="file.type == 'image/jpeg'">
                            <img role="presentation" :alt="file.name" :src="file.src" width="44" class="p-d-block"
                                :data-index="index" />
                        </div>
                        <div v-else><i class="pi pi-file-pdf p-tree p-d-inline-block"></i></div>
                        <div>{{ file.name }}</div>
                        <div class="p-d-flex p-jc-end">
                            <a :href="file.src" target="_blank" class="p-button p-button-icon-only p-mr-2"><i
                                    class="pi pi-download p-button-icon"></i></a>
                            <Button type="button" icon="pi pi-trash" @click="removeUpload(file)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db, storage } from '@/firebase';

export default {
    props: ['user', 'logsMeta'],
    data() {
        return {
            selectedRows: [],
            filters: {},
            loading: true,
            templateDocuments: [],
            templateProperties: [],
            template: {},
            selected: {
                name: '',
                key: '',
            },
            editName: false,
            editProp: {},
            visibleRight: false,
            displayConfirmation: false,
            uploadValue: 0,
        }
    },
    firestore() {
        return {
            template: db.collection('templates').doc(this.$route.params.id),
            templateProperties: {
                ref: db.collection('template_properties').where('template_id', '==', this.$route.params.id).where('disabled', '==', false),
                resolve: (data) => {
                    this.loading = false
                }
            },
            templateDocuments: db.collection('template_docs').where('template_id', '==', this.$route.params.id),
            documents: db.collection('template_docs'),
            properties: db.collection('template_properties'),
        }
    },
    methods: {
        openConfirmation(event, id) {
            if (id) {
                this.selected.key = id;
            }
            this.displayConfirmation = true;
        },
        closeConfirmation(confirm) {
            if (confirm) {
                this.$firestore.properties.doc(this.selected.key).set({ disabled: true }, { merge: true }).then(() => {
                    this.selected.key = '';
                    this.selectedRows = [];
                    this.displayConfirmation = false;
                    this.multipleDelete = true;
                    db.collection('logs').add({
                        activity: 'Property deleted',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key
                    }).then(() => {
                        db.collection('meta').doc('logs').update({
                            'count': this.logsMeta.count + 1,
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Property deleted', life: 3000 });
                        });
                    });
                });
            }
            this.displayConfirmation = false;
        },
        addProperty: function () {
            if (this.selected.name != '') {
                if (this.selected.key != '') {
                    this.$firestore.properties.doc(this.selected.key).update({ name: this.selected.name, value: this.selected.value }).then(() => {
                        this.selected.name = '';
                        this.selected.key = '';
                        this.selected.value = '';
                        this.visibleRight = false;
                        db.collection('logs').add({
                            activity: 'Property updated',
                            timestamp: new Date(),
                            user: this.user.email,
                            client_id: this.user.client.key
                        }).then(() => {
                            db.collection('meta').doc('logs').update({
                                'count': this.logsMeta.count + 1,
                            }).then(() => {
                                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Property updated', life: 3000 });
                            });
                        });
                    });
                } else {
                    this.$firestore.properties.add(
                        {
                            template_id: this.$route.params.id,
                            name: this.selected.name,
                            value: this.selected.value,
                            timestamp: new Date(),
                            disabled: false
                        }
                    ).then(() => {
                        this.selected.name = '';
                        this.selected.value = '';
                        this.visibleRight = false;
                        db.collection('logs').add({
                            activity: 'New property added',
                            timestamp: new Date(),
                            user: this.user.email,
                            client_id: this.user.client.key
                        }).then(() => {
                            db.collection('meta').doc('logs').update({
                                'count': this.logsMeta.count + 1,
                            }).then(() => {
                                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New property added', life: 3000 });
                            });
                        });
                    });
                }
            }
        },
        saveName() {
            this.$firestore.template.update({ 'name': this.editName, 'category': this.editCategory }).then(() => {
                this.editName = '';
                db.collection('logs').add({
                    activity: 'Template name/category updated',
                    timestamp: new Date(),
                    user: this.user.email,
                    client_id: this.user.client.key
                }).then(() => {
                    db.collection('meta').doc('logs').update({
                        'count': this.logsMeta.count + 1,
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Template name/category updated', life: 3000 });
                    });
                });
            });
        },
        startUpload(event) {
            event.files.forEach(file => {
                let uniqueName = Date.now() + '_' + file.name;
                this.$refs.uploader.progress = 0;
                this.getFileBlob(file.objectURL, blob => {
                    const storageRef = storage.ref('template/' + this.template.key + '/' + uniqueName).put(blob);
                    storageRef.on(`state_changed`, snapshot => {
                        this.$refs.uploader.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, error => {
                    }, () => {
                        this.$refs.uploader.progress = 100;
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            const doc = {
                                src: url,
                                type: file.type,
                                name: file.name,
                                uniqueName: uniqueName,
                                template_id: this.template.key
                            }
                            this.$firestore.documents.add(doc).then(() => {
                                this.file = {};
                                this.fileData = null;
                            });
                        });
                    });
                });
            });
            db.collection('logs').add({
                activity: 'File(s) uploaded',
                timestamp: new Date(),
                user: this.user.email,
                client_id: this.user.client.key
            }).then(() => {
                db.collection('meta').doc('logs').update({
                    'count': this.logsMeta.count + 1,
                }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File(s) uploaded', life: 3000 });
                });
            });
            this.$refs.uploader.clear();
        },
        removeUpload(file) {
            const storageRef = storage.ref();
            const docRef = storageRef.child('template/' + this.template.key + '/' + file.uniqueName);
            docRef.delete().then(() => {
                // File deleted successfully
                this.$firestore.documents.doc(file.key).delete().then(() => {
                    db.collection('logs').add({
                        activity: 'File deleted',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key
                    }).then(() => {
                        db.collection('meta').doc('logs').update({
                            'count': this.logsMeta.count + 1,
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'File deleted', life: 3000 });
                        });
                    });
                });
            }).catch(() => {
                // Uh-oh, an error occurred!
            });
        },
        getFileBlob(url, cb) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.addEventListener('load', function () {
                cb(xhr.response);
            });
            xhr.send();
        }
    }
}
</script>

<style scoped lang="scss">
.p-fileupload-row {
    word-break: break-all;
}</style>
